import { FC } from 'react';

export function withOrganizationSidebar<T>(Component: FC<T>) {
  return (props: Parameters<typeof Component>[0]): JSX.Element => {
    return <Component {...props} />;
  };
}
